import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=58a5c5bc"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"
import "./AudioPlayer.vue?vue&type=style&index=0&id=58a5c5bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports